var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid mt-5"},[_c('div',{staticClass:"row justify-content-center align-items-center"},[_c('div',{staticClass:"col-md-12 col-sm-12 col-lg-12 mt-5"},[_c('div',{staticClass:"card main-card"},[_c('div',{staticClass:"card-body"},[_c('h1',[_vm._v("Logs")])])])])])])
}]

export { render, staticRenderFns }